import React from 'react';
import ReactDOMServer from 'react-dom/server';
import { TutorialButton } from '@ro-components/Tutorial';

export const spTutorial = (id, buttonText) => [
  {
    element: '.sp_shortcut',
    intro: 'W sekcji z ustawieniami możesz tworzyć skróty które dostępne będą z lewej strony pulpitu.'
  },
  {
    element: '.sp_framealpha',
    intro: 'Takie suwaki są bardzo użyeczne, możesz np. ustawić przezroczystość ramki poligonu'
  },
  {
    element: '.sp_fillalpha',
    intro: `Drugi suwak ustawia przezroczystość wypełnienia (środka) poligonu. ${ReactDOMServer.renderToStaticMarkup(
      <TutorialButton id={id} text={buttonText} />
    )}`
  }
];
